import React from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import UserSettingManager from "./managers/UserSettingManager";
import ResizeManager from "./managers/ResizeManager";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <UserSettingManager />
        <ResizeManager />
        <AppRoutes />
      </div>
    </HelmetProvider>
  );
}

export default App;
